import { Module } from 'vuex';
import FleetState from './types/IFleetState';
import IRootState from '@/store/types/IRootState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const fleet: Module<FleetState, IRootState> = {
  namespaced: true,
  state: {
    meta: {
      title: '',
      description: '',
    },
    header: {
      title: '',
      description: '',
      image: '',
    },
    fleet: [],
  },
  actions,
  getters,
  mutations,
};

export default fleet;
